import {
  params, shape, number, bool, arrayOf, extend,
  string, customType
} from '@thd-nucleus/data-sources';
import {
  SORT_KEY_PROJECT_ID,
  SORT_KEY_PROJECT_STATUS,
  SORT_KEY_PROJECT_NAME,
  SORT_KEY_LAST_MODIFIED
} from './project-summary-helper';

const filterType = customType('Filter').shape({
  searchBy: customType('searchBy').enum([SORT_KEY_PROJECT_NAME], SORT_KEY_PROJECT_NAME),
  search: string()
});
const sortType = customType('Sort').shape({
  sortBy: customType('sortBy').enum([SORT_KEY_PROJECT_NAME, SORT_KEY_LAST_MODIFIED,
    SORT_KEY_PROJECT_ID, SORT_KEY_PROJECT_STATUS], SORT_KEY_PROJECT_NAME),
  sortOrder: customType('sortOrder').enum(['ASC', 'DSC'], 'ASC')
});

export const dataModel = extend({
  projects: params({
    page: number(),
    pageSize: number(),
    accountId: string().isRequired(),
    filter: arrayOf(filterType),
    sort: arrayOf(sortType)
  }).shape({
    totalProjects: number(),
    projects: arrayOf(
      shape({
        id: string(),
        projectId: string(),
        projectName: string(),
        status: string(),
        modifyDateTime: string(),
        createdBy: string(),
        createdByName: string(),
        isCreatedByTHDAssociate: bool(),
        numberOfItems: number().skip('skipNumberOfItems', true),
        images: arrayOf(string()).skip('skipImages', true),
        hasTradeCreditAttached: bool()
      })
    )
  })
});
